import axios from "axios";

import { BASE_URL } from "../../utils/constants";
import { APP_SCHEMA_VERSION } from "../../constants/schemaVersion";

export const loginWithEmail = (email, password) =>
  axios.post(`${BASE_URL}/users/auth/login/`, { email, password });

export const loginWithGoogle = (credential) =>
  axios.post(`${BASE_URL}/users/auth/google/`, { credential });

/**
 * Apply the post-login response to local + session storage. Mirrors the
 * historical inline block in LoginPage.js so the email/password flow and
 * the Google flow stay in lockstep. Returns the user for caller-side
 * role branching.
 */
export const applyAuthSuccess = ({ access, refresh, user }) => {
  localStorage.setItem("authToken", access);
  if (refresh) {
    localStorage.setItem("refreshToken", refresh);
  }
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("schema_version", String(APP_SCHEMA_VERSION));

  if (user?.external_role?.name === "TOCA Admin") {
    // Caller will trigger refetchOrgs.
  } else {
    localStorage.setItem("fallback_org", JSON.stringify(user?.account));
    sessionStorage.setItem("acc_id", user?.account?.id);
    sessionStorage.setItem("acc_name", user?.account?.name);
    sessionStorage.setItem("schema_name", user?.account?.schema_name);
  }

  if (user?.account_roles?.some((role) => role.name === "Patient")) {
    sessionStorage.setItem("_pt_id", user.patient_id);
    sessionStorage.setItem("rpm", user.rpm_enrolled);
    sessionStorage.setItem("ccm", user.ccm_enrolled);
  }

  if (
    user?.account_roles?.some((role) => role.name === "Patient") ||
    user?.account_roles?.some((role) => role.name === "Case Manager")
  ) {
    sessionStorage.setItem(
      "current_loc",
      JSON.stringify({ id: user?.current_location })
    );
  }

  return user;
};

/**
 * Backend-defined error codes returned in `response.data.error` for
 * Google sign-in failures. Confirmed by the backend dev:
 * - `google_account_not_allowed`: verified Google email has no matching
 *   active TOCA AuthUser.
 * - `email_not_verified`: id_token's `email_verified` claim is false.
 */
export const GOOGLE_ACCOUNT_NOT_ALLOWED = "google_account_not_allowed";
export const EMAIL_NOT_VERIFIED = "email_not_verified";

const matchesGoogleErrorCode = (error, code) => {
  const data = error?.response?.data;
  if (!data) return false;
  return data.error === code || data.code === code || data.detail === code;
};

export const isGoogleAccountNotAllowed = (error) =>
  matchesGoogleErrorCode(error, GOOGLE_ACCOUNT_NOT_ALLOWED);

export const isGoogleEmailNotVerified = (error) =>
  matchesGoogleErrorCode(error, EMAIL_NOT_VERIFIED);
